export default function Formats() {
  const formats = [
    { icon: 'ri-presentation-line', title: 'Корпоративный тренинг', desc: 'Интенсив 1–2 дня для всей команды с практикой на реальных звонках компании.' },
    { icon: 'ri-user-voice-line', title: 'Практикум по холодным звонкам', desc: 'Углублённая отработка навыка: открытие, удержание, закрытие на следующий шаг.' },
    { icon: 'ri-file-list-3-line', title: 'Разбор записей разговоров', desc: 'Детальный анализ реальных звонков менеджеров с обратной связью и рекомендациями.' },
    { icon: 'ri-map-pin-line', title: 'Полевое сопровождение', desc: 'Тренер работает вместе с менеджерами в реальных условиях, корректируя на ходу.' },
    { icon: 'ri-video-chat-line', title: 'Онлайн', desc: 'Живые сессии с отработкой звонков через видеосвязь, разбор кейсов и записей.' },
    { icon: 'ri-building-line', title: 'Очное обучение', desc: 'Офлайн-формат в вашем офисе или на площадке в Минске, максимальное погружение.' },
    { icon: 'ri-stack-line', title: 'Модульная программа', desc: '2–6 модулей с практикой между встречами и домашними заданиями.' },
    { icon: 'ri-hand-heart-line', title: 'Долгосрочное сопровождение', desc: 'Поддержка 3–12 месяцев: разборы, корректировка, чат с тренером, аудит звонков.' },
  ];

  return (
    <section id="formats" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Выбирайте формат под задачи, бюджет и географию команды. Каждый формат можно адаптировать под ваши цели и специфику бизнеса.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {formats.map((f, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all duration-300">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${f.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}